<template>
  <div class="col-md-6 offset-md-3">
    <div class="login-form mt-4 p-4">
      <div class="row g-3">
        <h4>Восстановление завершено</h4>
        <p>Установлен новый пароль</p>
        <div class="col-12">
          <button type="submit" class="btn btn-dark float-end ms-3" @click="handleClickActionRestoreFinish">Продолжить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields } from "@/plugins/ws";

import {RootState} from "@/store";

defineOptions({
  name: 'ComponentsAuthRestoreSuccess',
});

interface RestoreFinishPayload {
  idUser: number;
  name: string;
  email: string;
  theme: string;
  admin: boolean;
  confirmEmail: boolean;
  register: Record<string, unknown>;
  newPassword: Record<string, unknown>;
  restorePassword: Record<string, unknown>;
}

const emit = defineEmits<{
  resubscribePage: [];
  switchMode: [mode: string];
}>();

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента RestoreSuccess
type RestoreSetPasswordFinishMessage = WebSocketMessageWithFields<'auth-restore-set-password-finish', {
  auth: {
    idUser: number;
    name: string;
    email: string;
    theme: string;
    admin: boolean;
    confirmEmail: boolean;
    register: Record<string, unknown>;
    newPassword: Record<string, unknown>;
    restorePassword: Record<string, unknown>;
  };
}>;

// Объединенный тип для всех сообщений
type RestoreSuccessWebSocketMessageType = RestoreSetPasswordFinishMessage;

const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload?: any) => void;

const latestMessageValue = ref(latestMessage);

// WebSocket message handler
const handleWebSocketMessage = (data: RestoreSuccessWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-restore-set-password-finish':
      signalRestoreFinish({
        idUser: data.auth.idUser,
        name: data.auth.name,
        theme: data.auth.theme,
        email: data.auth.email,
        admin: data.auth.admin,
        confirmEmail: data.auth.confirmEmail,
        register: data.auth.register,
        newPassword: data.auth.newPassword,
        restorePassword: data.auth.restorePassword,
      });
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRestoreFinish = () => {
  wsSend('authRestoreSetPasswordFinish');
  emit('resubscribePage');
};

const signalRestoreFinish = (payload: RestoreFinishPayload) => {
  store.dispatch('auth/wsSetUser', payload);
  emit('switchMode', 'login');
};
</script>

<style scoped>

</style>